export default __webpack_public_path__ + "static/feature-bg-dc4c470a9d8a8cdb680c950a41f2120d.jpg";